import { render, staticRenderFns } from "./UploadFileMobile.vue?vue&type=template&id=61b059d1&scoped=true"
import script from "./UploadFileMobile.vue?vue&type=script&lang=js"
export * from "./UploadFileMobile.vue?vue&type=script&lang=js"
import style0 from "./UploadFileMobile.vue?vue&type=style&index=0&id=61b059d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b059d1",
  null
  
)

export default component.exports